import { Button } from '@/app/components/ui/button';
import { Dialog, DialogContent } from '@/app/components/ui/dialog';
import { Role } from '@prisma/client';
import { useSession } from 'next-auth/react';
import { useParams } from 'next/navigation';
import React from 'react';
import { Loader2 } from 'lucide-react';

interface TermsAcceptancePopupProps {
    auctionId: number;
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    onAccept: () => Promise<void>;
    onViewTerms: () => void;
}

const TermsAcceptancePopup = ({ auctionId, isOpen, onOpenChange, onViewTerms, onAccept }: TermsAcceptancePopupProps) => {
    const session: any = useSession();

    if (!session || session.data?.role !== Role.BUYER) {
        return null;
    }

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent className="flex flex-col gap-4 z-50">
                <div className="text-lg font-medium">
                    Terms & Conditions
                </div>
                <div className="text-sm text-foreground mt-2 mb-4">
                    Please read the auction&apos;s terms and conditions before placing a bid.
                    By bidding, you acknowledge and accept these terms.
                </div>
                <div className="flex gap-2">
                    <Button
                        variant="outline"
                        className="w-1/2"
                        onClick={() => {
                            window.open(`/auctions/${auctionId}/terms`, '_blank');
                            onViewTerms();
                        }}
                    >
                        View terms
                    </Button>
                    <Button
                        className="w-1/2 bg-indigo-600 hover:bg-indigo-700"
                        onClick={async () => await onAccept()}
                    >
                        I accept
                    </Button>
                </div>
            </DialogContent>
        </Dialog >
    );
};

export default TermsAcceptancePopup;